import React, { useEffect, useState } from 'react';
import syncService from '../services/syncService';

const LABELS = {
  local: { text: 'Local only', dot: 'bg-slate-400', hint: 'Your data is saved on this computer only.' },
  syncing: { text: 'Syncing…', dot: 'bg-amber-400 animate-pulse', hint: 'Saving your changes to the cloud.' },
  synced: { text: 'Synced', dot: 'bg-green-400', hint: 'Your songs, verses, run-sheets and settings are backed up.' },
  offline: { text: 'Offline', dot: 'bg-slate-400', hint: 'No connection. Changes are saved here and will sync when you are back online.' },
  error: { text: 'Sync error', dot: 'bg-red-500', hint: 'Could not sync.' },
};

/** Small cloud-sync indicator for the header. */
const SyncStatus = ({ dm }) => {
  const [state, setState] = useState({ status: syncService.status, error: syncService.error });

  useEffect(() => {
    setState({ status: syncService.status, error: syncService.error });
    return syncService.onStatus(setState);
  }, []);

  const info = LABELS[state.status] || LABELS.local;
  const title = state.error ? `${info.hint} ${state.error}` : info.hint;
  return (
    <div
      role="status"
      title={title}
      className={`flex items-center gap-1.5 text-xs font-semibold ${dm ? 'text-slate-300' : 'text-gray-600'}`}
    >
      <span className={`w-2 h-2 rounded-full ${info.dot}`} />
      <span className="hidden md:inline">{info.text}</span>
    </div>
  );
};

export default SyncStatus;
